import { Component, OnInit } from "@angular/core";
import { InitalizeService } from '../services/initalize.service';

@Component({
    selector: "pi-promote",
    templateUrl: "./promote.component.html",
    styleUrls: ["./promote.component.scss"],
    standalone: false
})
export class PromoteComponent implements OnInit {

  constructor(private initalizeService: InitalizeService) {
    this.initalizeService.setSplashScreen(false);
  }

  ngOnInit() {}
}
